class TeamRequestsModalApproveAllConfirmController {
  constructor() {
  }
  $onInit(){
    this.floatingActionButtons = this.getFloatingActionButtons();
  }

  approveAll() {
    this.onApproveAll();
  }

  getFloatingActionButtons() {
    return [
      {
        literal: 'VACATIONS_ABSENCES.GENERAL.APPROVE_ALL'
      }, {
        literal: 'GLOBALS.BUTTON_ACTION.CANCEL'
      }
    ];
  }

  onDismiss(){
    angular.element('.modal').modal('hide');
  }
}

export default TeamRequestsModalApproveAllConfirmController;



// WEBPACK FOOTER //
// ./client/app/vacations-absences.module/features/teamRequests/teamRequestsModalApproveAll/teamRequestsModalApproveAllConfirm/teamRequestsModalApproveAllConfirm.controller.js